import React, { type PropsWithChildren } from "react";

import ContextState from "@/context/State";
import Layout from "@/components/Layout/Layout";
import ContextSanctioned from "@/context/Sanctioned";

import "@/styles/globals.scss";

export default function ContextInternal({ children }: PropsWithChildren) {
  return (
    <ContextState>
      <ContextSanctioned>
        <Layout>{children}</Layout>
      </ContextSanctioned>
    </ContextState>
  );
}
